<template>
  <v-card class="px-5">
    <v-row>
      <v-col cols="3" class="mx-n1">
        <v-row class="justify-center ">
          <v-avatar size="42px" color="#0049B740">
            <v-icon size="22px" v-text="icon" color="#0049B7" />
          </v-avatar>
        </v-row>
      </v-col>
      <v-col cols="9">
        <div class="ml-1">
          <v-row>
            <div v-text="title" class="primary--text text-h6" />
          </v-row>

          <v-row class="justify-space-between">
            <div>
              <span class="text-subtitle-2">วันลาที่ใช้ไป</span>
            </div>
            <div>
              <span class="primary--text text-h6 mr-1">{{ leaveAmount }}</span>
              <span class="text-subtitle-2">{{ leaveDayName }}</span>
            </div>
          </v-row>
        </div>
      </v-col>
    </v-row>

    <v-row><v-divider /></v-row>
    <v-row class="justify-space-between py-2">
      <div class="d-flex align-end">
        <span class="text-subtitle-2">วันลาคงเหลือ</span>
      </div>

      <div>
        <span class="error--text text-h6">
          {{
            parseFloat(leaveDayAll) - parseFloat(leaveAmount) > 0
              ? parseFloat(leaveDayAll) - parseFloat(leaveAmount)
              : 0
          }}
        </span>
        /
        <span class="gray--text mr-1 text-subtitle-2">{{ leaveDayAll }}</span>
        <span class="text-subtitle-2">{{ leaveDayName }}</span>
      </div>
    </v-row>

    <!-- <div v-html="footer" class="body-2 py-2 text-right" /> -->
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Untitled'
    },
    subTitle: {
      type: String,
      default: 'Unsubtitled'
    },
    icon: {
      type: String,
      default: 'mdi-account-multiple-outline'
    },
    footer: {
      type: String,
      default: 'Unfooted'
    },
    leaveDayName: {
      type: String,
      default: '-'
    },
    leaveAmount: {
      type: String,
      default: '-'
    },
    leaveDayAll: {
      type: String,
      default: '-'
    }
  }
}
</script>
